import { Component, inject, linkedSignal, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { UserDataService } from '../../services/user-data.service';
import { UpperCasePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { RegisteredSerialsService } from '../../services/registered-serials.service';
import { RegisterSerialRequest } from '../../models/register-serial-request';
import { MessageComponent } from '../message/message.component';
import { NgxTurnstileComponent, NgxTurnstileFormsModule } from "ngx-turnstile";
import { Utils } from '../../services/utils.service';
import { environment } from '../../../environments/environment';
import { Modal, ModalDismissReasons, ModalService } from '../../services/modal.service';

@Component({
  selector: 'modal-add-product',
  imports: [TranslatePipe, FormsModule, ReactiveFormsModule, UpperCasePipe, NgxTurnstileComponent, NgxTurnstileFormsModule],
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.scss']
})
export class AddProductComponent implements OnInit {

  private modal = inject(Modal);
  private fb = inject(FormBuilder);
  private userDataService = inject(UserDataService);
  private translate = inject(TranslateService);
  private spinner = inject(NgxSpinnerService);
  private registeredSerialsService = inject(RegisteredSerialsService);
  private utils = inject(Utils);
  private modalService = inject(ModalService);

  error = signal<string>('');
  success = signal<boolean>(false);
  productForm!: FormGroup;
  trainers = linkedSignal(() => this.userDataService.trainers());
  siteKey = environment.turnstileSiteKey;
  turnstileVisible = signal<boolean>(true);
  submitted = false;

  ngOnInit(): void {
    this.productForm = this.fb.group({
      trainerCode: [0, [Validators.required, Validators.min(1)]],
      serial: ['', [Validators.required]],
      check: [false, [Validators.requiredTrue]],
      token: ['', [Validators.required]],
    });
  }

  close() {
    this.modal.dismiss(ModalDismissReasons.CANCEL);
  }

  confirm() {
    this.submitted = true;
    if (!this.productForm.valid) {
      return;
    }
    const request: RegisterSerialRequest = {
      serialCode: this.productForm.get('serial')?.value,
      trainerCode: Number(this.productForm.get('trainerCode')?.value),
      token: this.productForm.get('token')?.value,
    };
    this.spinner.show();
    this.registeredSerialsService.registerSerial(request).subscribe({
      next: _ => {
        this.spinner.hide();
        const modal = this.modalService.show(MessageComponent);
        modal.componentInstance.message.set(this.translate.instant('product_registered'));
        modal.dismissed.subscribe({
          next: _ => {
            this.modal.dismiss(ModalDismissReasons.OK);
          }
        });
      },
      error: error => {
        this.spinner.hide();
        this.turnstileVisible.set(false);
        const modal = this.utils.showMessage(error, this.utils.getErrorMessage(error, this.userDataService.user()?.email ?? ''));
        if (modal) {
          modal.dismissed.subscribe({
            next: _ => {
              this.turnstileVisible.set(true);
            }
          });
        }
      }
    });
  }
}
